<template>
    <div class="team_list mt-5">
        <ul>
            <li>
                <div class="p_img">
                    <img src="http://img01.jhcms.com/demo/default/staff_face.png"/>
                </div>
                <div class="p_info">
                    <div class="tit">
                        <div class="name">谭浩</div>
                        <em>认证</em>
                        <em>签约</em>
                    </div>
                </div>
            </li>
            <li>
                <div class="p_img">
                    <img src="http://img01.jhcms.com/demo/default/staff_face.png"/>
                </div>
                <div class="p_info">
                    <div class="tit">
                        <div class="name">谭浩</div>
                        <em>认证</em>
                        <em>签约</em>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'Team'
}
</script>

<style scoped>
    .team_list{background:#fff;}
    .team_list li{padding: .5rem .45rem;height:4rem;border-bottom: 1px solid #e6e6e6;}
    .team_list li .p_img{width:4rem;height:4rem;float:left;border-radius:100%;}
    .team_list li .p_img img{width:100%;height:100%;}
    .team_list li .p_info{margin-left:4.5rem;}
    .team_list li .p_info .tit{margin-bottom:0.5rem;overflow: hidden;vertical-align: middle;height:1rem;}
    .team_list li .p_info .tit .name{line-height:1rem;font-size:0.8rem;float:left;}
    .team_list li .p_info .tit em{float:right;display: block;padding: 0.1rem 0.4rem;line-height: 0.8rem;font-size: 0.55rem;color: #fff;margin-left: 0.2rem;background: #4ad28b;border-radius: 5rem;}
</style>
